export const RedirectRoutingKeyParams = {
    ng1: 'ng1',
    external: 'external',
};
